import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as SearchGenresThemesActions from 'rebook/apps/search/actions/SearchGenresThemesActions';
import GenreList from 'rebook/apps/catalog/components/GenreList';
import BackLink from 'rebook/apps/base/components/BackLink';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


class SearchGenresThemesView extends React.Component {
  componentDidMount() {
    this.props.SearchGenresThemesActions.fetchInitialData(this.props.location);
  }

  componentWillUnmount() {
    this.props.SearchGenresThemesActions.resetData();
  }

  render() {
    const { genresList, nichesList, tagsList, genresThemesCount, query } = this.props.searchGenresThemes;

    return (
      <div className="backgroundContainer themeGrey">
        <div className="section">
          <BackLink link={`/search/?q=${query}`}
            extraClassName={styles.breadCrumbs}
            isMargined>
            <span className="link">Все результаты</span>
          </BackLink>
          <div className="title-1">Все жанры и темы по запросу «{query}»</div>
          {genresThemesCount > 0 && (
            <small>
              {genresThemesCount} {pluralize(genresThemesCount, 'жанр или тема', 'жанра и темы', 'жанров и тем') }
            </small>
          )}
          <GenreList genres={genresList} niches={nichesList} tags={tagsList} />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    searchGenresThemes: state.searchGenresThemes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    SearchGenresThemesActions: bindActionCreators(SearchGenresThemesActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchGenresThemesView);
